<script setup>
import { computed, ref } from 'vue';
import FileIcon from 'dashboard/components-next/icon/FileIcon.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import WhatsAppTemplateButtons from './WhatsAppTemplateButtons.vue';

const props = defineProps({
  message: {
    type: Object,
    required: true,
  },
});

const PDF_EXTENSIONS = ['.pdf', 'pdf'];
const VIDEO_EXTENSIONS = ['.mp4', '.mov', 'video'];
const DOC_EXTENSIONS = ['.doc'];

// URLs de exemplo da Meta (scontent.whatsapp.net) expiram; sem o fallback o
// mockup fica com um buraco em vez da área de mídia.
const mediaFailed = ref(false);

const mediaType = computed(() => {
  if (props.message.mediaType) return props.message.mediaType;

  const format = props.message.header?.format;
  if (format) return format.toLowerCase();

  const url = props.message.image_url || '';
  if (PDF_EXTENSIONS.some(ext => url.includes(ext))) return 'document';
  if (VIDEO_EXTENSIONS.some(ext => url.includes(ext))) return 'video';
  return 'image';
});

const fileType = computed(() => {
  const url = props.message.image_url || '';
  return DOC_EXTENSIONS.some(ext => url.includes(ext)) ? 'doc' : 'pdf';
});
</script>

<template>
  <div class="rounded-2xl bg-n-alpha-2 text-n-slate-12 max-w-80">
    <div class="flex flex-col gap-2.5 p-3">
      <img
        v-if="mediaType === 'image' && message.image_url && !mediaFailed"
        :src="message.image_url"
        class="object-cover w-full max-h-44 rounded-xl"
        alt="Template media"
        @error="mediaFailed = true"
      />
      <div
        v-else-if="mediaType === 'image'"
        class="flex justify-center items-center w-full h-32 rounded-xl bg-n-alpha-1 text-n-slate-10"
      >
        <Icon icon="i-lucide-image" class="size-8" />
      </div>

      <div
        v-else-if="mediaType === 'video'"
        class="overflow-hidden relative rounded-xl"
      >
        <video
          :src="message.image_url"
          class="object-cover w-full max-h-44"
          controls
          preload="metadata"
        />
      </div>

      <div v-else-if="mediaType === 'document'" class="flex items-center">
        <FileIcon :file-type="fileType" class="text-2xl text-n-slate-12" />
      </div>

      <span
        v-if="message.content"
        v-dompurify-html="message.content"
        class="text-sm font-medium prose prose-bubble"
      />

      <div v-if="message.footer" class="text-xs opacity-70 text-n-slate-11">
        {{ message.footer }}
      </div>
    </div>
    <WhatsAppTemplateButtons
      :buttons="message.buttons || []"
      :call-permission-request="Boolean(message.hasCallPermissionRequest)"
    />
  </div>
</template>
